import { memo, ReactElement, useCallback, useMemo } from 'react';
import { Button, Dropdown, MenuProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { ActionEntityType } from '@pmp/api';
import { ImportButtonProps } from './interfaces';

export const ImportButton = memo(({ entityTypes, onImport }: ImportButtonProps): ReactElement => {
  const { t } = useTranslation();

  const onClick = useCallback(
    ({ key }: { key: string }) => {
      onImport(key as ActionEntityType);
    },
    [onImport],
  );

  const items: MenuProps['items'] = useMemo(
    () => entityTypes.map(entityType => ({ key: entityType, label: t(`pmp.entities.${entityType}`) })),
    [entityTypes, t],
  );

  return (
    <Dropdown menu={{ items, onClick }} placement="bottomLeft" trigger={['click']}>
      <Button icon={<UploadOutlined />} type="primary">
        {t('global.buttons.import')}
      </Button>
    </Dropdown>
  );
});
